import { render } from "./LogoutModal.vue?vue&type=template&id=4f69955a"
import script from "./LogoutModal.vue?vue&type=script&lang=js"
export * from "./LogoutModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__